'use strict';

exports.__esModule = true;
exports.deafultFieldProperties = exports.InitialState = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = translationReducer;

var _immutable = require('immutable');

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InitialState = exports.InitialState = (0, _immutable.Record)({
  fields: new _immutable.Map(),
  forms: new _immutable.Map()
});

var initialState = new InitialState();

var deafultFieldProperties = exports.deafultFieldProperties = (0, _immutable.Map)({
  value: '',
  liveValidation: false,
  error: null,
  apiError: null
});

function reviveFields(fields) {
  return (0, _keys2.default)(fields).reduce(function (acc, field) {
    return acc.set(field, deafultFieldProperties.merge(fields[field]));
  }, new _immutable.Map());
}

function revive(state) {
  var fields = state.fields || {};
  return (0, _keys2.default)(fields).reduce(function (acc, form) {
    return acc.setIn(['fields', form], reviveFields(fields[form]));
  }, initialState);
}

/**
 * Translation Redux reducer
 * @param  {Object} inputState  App state
 * @param  {Object} action      Flux action
 * @return {Object}             Updated app state
 */
function translationReducer() {
  var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var state = !(inputState instanceof InitialState) ? revive(inputState) : inputState;

  switch (action.type) {
    case actions.REGISTER_ONION_FORM_FIELD:
      {
        var form = action.form,
            field = action.field;

        if (_immutable.Map.isMap(state.getIn(['fields', form, field]))) {
          return state;
        }
        return state.setIn(['fields', form, field], deafultFieldProperties);
      }

    case actions.SET_ONION_FORM_FIELD_PROPERTY:
      {
        var _form = action.form,
            _field = action.field,
            property = action.property,
            value = action.value;

        return state.setIn(['fields', _form, _field, property], value);
      }

    case actions.SET_ONION_FORM_MULTIPLE_FIELDS:
      {
        var _form2 = action.form,
            _property = action.property,
            values = action.values;

        return (0, _keys2.default)(values).reduce(function (acc, field) {
          return acc.setIn(['fields', _form2, field, _property], values[field]);
        }, state);
      }

    case actions.CLEAR_ONION_FORM:
      {
        var _form3 = action.form;

        var fields = state.getIn(['fields', _form3]) || [];
        return fields.reduce(function (acc, _, field) {
          return acc.setIn(['fields', _form3, field], deafultFieldProperties);
        }, state);
      }

    case actions.CLEAR_ONION_FORM_PROPERTY:
      {
        var _form4 = action.form,
            _property2 = action.property;

        var _fields = state.getIn(['fields', _form4]) || [];
        return _fields.reduce(function (acc, _, field) {
          return acc.setIn(['fields', _form4, field, _property2], null);
        }, state);
      }
  }

  return state;
}